import { DOM_IDS } from '../constants.js'
import { shouldShowHeaderSlots } from '../config.js'
import { waitForElement } from '../dom-helpers.js'
import { createSubApp } from './create-sub-app.js'

const loadLeftSlots = () => import('../left-slots.vue')

export async function mountLeftSlots({ header }) {
  if (!shouldShowHeaderSlots()) return

  const container = await waitForElement(DOM_IDS.LEFT_SLOTS)
  if (!container) return

  const { default: LeftSlots } = await loadLeftSlots()

  createSubApp({
    component: LeftSlots,
    container,
    scope: 'left-slots',
    props: {
      customs: header?.customs?.left ?? []
    }
  })
}
